import {BookmarkStore} from 'common/report/stores/bookmarks';
import {contextify, createRootContextHook} from 'common/util/react';

const context = contextify<BookmarkStore>();

export const BookmarkProvider = context.Provider;
export const BookmarkConsumer = context.Consumer;
export const useBookmark = createRootContextHook(`bookmarkStore`);
